import { LocalStorageKeys } from '@constants/enums';
import { useNavigate } from 'react-router-dom';
import { ORGANIZATION_ID, ORGANIZATION_LOG_URL } from '../constants';
import useWhiteLabelService from './useWhiteLabel.service';

interface IClearStorage {
  clearWhiteLabelStorage: () => void;
  clearLogoutStorage: () => void;
}

const useClearStorageService = (): IClearStorage => {
  const navigate = useNavigate();
  const { getWhiteLabelFromLocalStorage } = useWhiteLabelService();

  const SESSION_STORAGE_KEYS = [ORGANIZATION_ID, ORGANIZATION_LOG_URL];

  const onboardingItemsToRestore = [
    {
      key: LocalStorageKeys.ONBOARDING_PROCESS_DATA,
      value: localStorage.getItem(LocalStorageKeys.ONBOARDING_PROCESS_DATA),
    },
  ];

  const whiteLabelItemsToRestore = [
    {
      key: ORGANIZATION_ID,
      value: sessionStorage.getItem(ORGANIZATION_ID),
    },
    {
      key: ORGANIZATION_LOG_URL,
      value: sessionStorage.getItem(ORGANIZATION_LOG_URL),
    },
  ];

  const logOutItemsToRestore = [
    {
      key: LocalStorageKeys.VISIT_COUNT,
      value: localStorage.getItem(LocalStorageKeys.VISIT_COUNT),
    },
    {
      key: LocalStorageKeys.DO_NOT_SHOW_CONVERT,
      value: localStorage.getItem(LocalStorageKeys.DO_NOT_SHOW_CONVERT),
    },
  ];

  const restoreLocalStorageItems = (
    items: { key: string; value: string | null }[]
  ) => {
    localStorage.clear();
    sessionStorage.clear();
    items.forEach(({ key, value }) => {
      if (value) {
        if (SESSION_STORAGE_KEYS.includes(key)) {
          sessionStorage.setItem(key, value);
        } else {
          localStorage.setItem(key, value);
        }
      }
    });
    getWhiteLabelFromLocalStorage();
  };

  const clearWhiteLabelStorage = () => {
    restoreLocalStorageItems([
      ...onboardingItemsToRestore,
      ...whiteLabelItemsToRestore,
    ]);
  };

  const clearLogoutStorage = () => {
    restoreLocalStorageItems([
      ...onboardingItemsToRestore,
      ...whiteLabelItemsToRestore,
      ...logOutItemsToRestore,
    ]);
    navigate('/');
  };

  return { clearWhiteLabelStorage, clearLogoutStorage };
};

export default useClearStorageService;
